import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const STORAGE_PREFIX = 'ida.mt-banner.dismissed.';
const ISSUE_URL = 'https://github.com/myida/ida-core/issues/new?template=human-translation.yml';

export default function MachineTranslationBanner() {
  const { i18n, t } = useTranslation('common');
  const lng = i18n.resolvedLanguage ?? i18n.language ?? 'en';
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    if (lng === 'en') {
      setDismissed(true);
      return;
    }
    setDismissed(localStorage.getItem(STORAGE_PREFIX + lng) === '1');
  }, [lng]);

  if (lng === 'en' || dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(STORAGE_PREFIX + lng, '1');
    setDismissed(true);
  };

  return (
    <div className="border-b border-amber-200 bg-amber-50 px-6 py-2 text-xs text-amber-900">
      <div className="mx-auto flex max-w-7xl items-center gap-3">
        <span className="material-symbols-outlined text-amber-700" style={{ fontSize: 16 }}>
          translate
        </span>
        <span className="flex-1">
          {t('machineTranslation.notice', {
            defaultValue:
              'This locale was machine-translated as a Round-1 baseline. Native-speaker reviews welcome.',
          })}{' '}
          <a
            href={ISSUE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold underline underline-offset-2 hover:text-amber-700"
          >
            {t('machineTranslation.requestReview', {
              defaultValue: 'Submit a human-translation request →',
            })}
          </a>
        </span>
        <button
          onClick={dismiss}
          aria-label={t('machineTranslation.dismiss', { defaultValue: 'Dismiss' })}
          className="flex size-6 items-center justify-center rounded text-amber-700 transition-colors hover:bg-amber-100 hover:text-amber-900"
        >
          <span className="material-symbols-outlined" style={{ fontSize: 16 }}>
            close
          </span>
        </button>
      </div>
    </div>
  );
}
